// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
#discardReasonDialog {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

#discardReasonDialog .discard-reason-container {
  width: 35%;
  max-width: 400px;
  min-width: 320px;
  background: var(--tooltipFontColor);
  padding: 20px;
  border-radius: 10px;
  font-size: 16px;
}

#discardReasonDialog .dialog-title {
  font-weight: var(--listHeaderFontWeight);
  display: flex;
}

#discardReasonDialog .discard-dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

#discardReasonDialog .discard-dialog-footer button {
  margin-left: 10px;
}

#discardReasonDialog .autoCompleteLazyLoadinputDiv {
  height: 40px;
  border: var(--inputControlBorderSize) var(--inputControlBorderColor) solid;
  background-color: var(--tooltipFontColor);
}
#discardReasonDialog .autoCompleteInput {
  background-color: var(--tooltipFontColor);
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/popups/DiscardReasonsPopup/DiscardReasonsPopup.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0EAA0E;EAC1E,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n#discardReasonDialog {\n  position: fixed;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#discardReasonDialog .discard-reason-container {\n  width: 35%;\n  max-width: 400px;\n  min-width: 320px;\n  background: var(--tooltipFontColor);\n  padding: 20px;\n  border-radius: 10px;\n  font-size: 16px;\n}\n\n#discardReasonDialog .dialog-title {\n  font-weight: var(--listHeaderFontWeight);\n  display: flex;\n}\n\n#discardReasonDialog .discard-dialog-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n#discardReasonDialog .discard-dialog-footer button {\n  margin-left: 10px;\n}\n\n#discardReasonDialog .autoCompleteLazyLoadinputDiv {\n  height: 40px;\n  border: var(--inputControlBorderSize) var(--inputControlBorderColor) solid;\n  background-color: var(--tooltipFontColor);\n}\n#discardReasonDialog .autoCompleteInput {\n  background-color: var(--tooltipFontColor);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
